import {
  type ContractDataType,
  type SpecContractStatusType,
} from '@/common/types/contract';

const getStatusBySpecContractData = (
  contractData?: ContractDataType,
): SpecContractStatusType | undefined => {
  // if (!contractData) {
  //   return 'forViewing';
  // }

  if (!contractData) return;

  // const contractKind = contractData?.type || kind;

  // const requirementLevel =
  //   contractKind in specContractRequirenments
  //     ? specContractRequirenments[
  //         contractKind as keyof typeof specContractRequirenments
  //       ].level
  //     : 1;

  // if (userLevel < requirementLevel) {
  //   return 'forViewing';
  // }

  // if (!contractData) {
  //   return 'wait';
  // }

  const {
    isOpened,
    createdAt,
    timeLeft,
    type,
    contractTimerExtensionCost,
    contractTimerExtensionDuration,
    contractTimerExtensionLimitTimeSinceOpened,
  } = contractData;

  if (!isOpened && typeof timeLeft !== 'number') {
    return 'open';
  }

  if (
    !!isOpened &&
    ((typeof timeLeft === 'number' && timeLeft > 0) || type === 'Custom')
  ) {
    return 'inProgress';
  }

  const contarcHasPaidExtraTime =
    contractTimerExtensionCost &&
    contractTimerExtensionDuration &&
    contractTimerExtensionLimitTimeSinceOpened;
  const timeToEndExpiredStatus =
    (contractTimerExtensionDuration || 0) * 1000 + (timeLeft || 0);
  const hasExpiredStatus =
    contarcHasPaidExtraTime && timeToEndExpiredStatus > 0;

  if (hasExpiredStatus) {
    return 'expired';
  }

  if (
    isOpened &&
    createdAt &&
    typeof timeLeft === 'number' &&
    timeLeft <= 0 &&
    !hasExpiredStatus
  ) {
    return 'fail';
  }

  return;
};

export { getStatusBySpecContractData };
